"use client";

import { MinusIcon, PlusIcon } from "lucide-react";
import Link from "@components/Link";
import { Disclosure } from "@headlessui/react";
import type { LayoutFooterNavigationFragment } from "@server/gql/graphql";
import { useState } from "react";

import { cn } from "@/lib/utils";

export default function FooterNavigation({
  data,
  locale,
}: {
  data: LayoutFooterNavigationFragment;
  locale: string | undefined;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Disclosure as="div">
      <h3 className="text-base">
        <Disclosure.Button
          onClick={() => setOpen(!open)}
          className="all-small-caps flex w-full items-center justify-between px-5 py-4 font-normal tracking-wider uppercase md:hidden"
        >
          {data?.title}
          <span className="text-lg md:hidden">
            {open && <MinusIcon strokeWidth={1} className="size-3" />}
            {!open && <PlusIcon strokeWidth={1} className="size-3" />}
          </span>
        </Disclosure.Button>

        <span className="all-small-caps mb-4 hidden font-normal tracking-wider uppercase md:block">
          {data?.title}
        </span>
      </h3>

      <Disclosure.Panel
        as="ul"
        static
        className={cn(
          "space-y-1 max-md:px-5",
          open ? "block" : "hidden md:block",
        )}
      >
        {data?.sublinksCollection?.items?.map((item) => {
          if (!item) return null;
          return (
            <li key={item?.sys.id}>
              <Link
                locale={locale}
                href={item.externalLink ?? item.internalLink?.slug ?? ""}
                className="hover:underline"
              >
                {item?.title}
              </Link>
            </li>
          );
        })}
      </Disclosure.Panel>
    </Disclosure>
  );
}
